import OfferCard from './offerCard';
import { motion } from 'framer-motion';

function HPHiw() {
    return (
        <section>
        <h2>Rechnung erstellen - so funktioniert es</h2>
            <motion.div 
                className='hiwContainer'
                initial={{ opacity: 0, y: -50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1 }}
                viewport={{ once: true, amount: 0.2 }}
            >
                <OfferCard index={4} offerCardTitle='Account erstellen' offerCardDescription='Klick oben rechts auf Anmelden und dann unten auf "Hier registrieren."' />
                <OfferCard index={5} offerCardTitle='Unternehmensinformationen eingeben' offerCardDescription='Gehe zu den Einstellungen und gib bei Firmendaten die nötigen Infos an. Diese werden dann auf der Rechnung stehen.' />
                <OfferCard index={6} offerCardTitle='Kunde hinzufügen' offerCardDescription='Klicke auf Kunden und dann auf Kunde hinzufügen. Gib dann die Infos zu deinem Kunden ein, diese werden auch auf der Rechnung stehen.' />
                <OfferCard index={7} offerCardTitle='Rechnung erstellen' offerCardDescription='Klicke auf Rechnung und dann auf neue Rechnung. Gib da alles ein, was du brauchst und klicke dann auf Rechnung erstellen.' />
            </motion.div>
        </section>
    );
}

export default HPHiw;